module.exports = __webpack_public_path__ + "img/result_success.3b033f74.svg";